.linkIcon {
  display: inline-flex;
}
